import { $, $$ } from 'utils/dom';
import { loadImages } from 'utils/helper';
import Lightbox from 'modules/lightbox/Lightbox';

const checkCollision = (sideNoteArray, target, index) => {
  const previousSidenote = sideNoteArray[index - 1];
  if (previousSidenote) {
    const previousOffsetBottom =
      previousSidenote.offsetTop + previousSidenote.clientHeight;

    if (target.offsetTop <= previousOffsetBottom) {
      target.style.top = `${previousOffsetBottom}px`;
    } else {
      target.removeAttribute('style');
    }
  }
};

const textmediaInTexts = $$('.textmedia--intext');
const textmedias = $$('.textmedia');
if (textmedias.length) {
  textmedias.forEach(imageGallery => {
    const textmedia = new Lightbox(imageGallery, {
      selector: '.lightbox-toggle',
    });
    textmedia.init();
  });
}

const sidenotes = $$('.textmedia__sidenote');
if (sidenotes.length) {
  sidenotes.forEach((sidenote, index) => {
    const sidenoteButton = $('.textmedia__sidenote-button', sidenote);
    const sidenoteText = $('.textmedia__sidenote-text', sidenote);
    if (sidenoteButton) {
      sidenoteButton.addEventListener('click', () => {
        sidenoteButton.classList.toggle('is-less');
        sidenoteText.classList.toggle('is-more');

        // check collision on toggle
        if (textmediaInTexts.length) {
          textmediaInTexts.forEach(textmediaInText => {
            const inTextAsideSidenotes = $$(
              '.textmedia__sidenote-aside',
              textmediaInText
            );

            inTextAsideSidenotes.forEach((inTextAsideSidenote, index) => {
              inTextAsideSidenote.removeAttribute('style');
              checkCollision(inTextAsideSidenotes, inTextAsideSidenote, index);
            });
          });
        }
      });
    }

    const sidenoteNumber = $('.textmedia__sidenote-number', sidenote);
    const sidenoteAside = $('.textmedia__sidenote-aside', sidenote);
    if (sidenoteNumber) {
      sidenoteNumber.addEventListener('click', () => {
        const sidenoteAsides = $$('.textmedia__sidenote-aside');
        const isVisible = !sidenoteAside.classList.contains('is-hidden');

        sidenoteAsides.forEach(sidenoteAside => {
          sidenoteAside.classList.add('is-hidden');
          sidenoteAside.parentElement.classList.remove('is-active');
        });

        if (isVisible) {
          sidenoteAside.classList.add('is-hidden');
          sidenoteAside.parentElement.classList.remove('is-active');
        } else {
          sidenoteAside.classList.remove('is-hidden');
          sidenoteAside.parentElement.classList.add('is-active');
        }
      });
    }

    const sidenoteClose = $('.textmedia__sidenote-close-button', sidenote);
    sidenoteClose &&
      sidenoteClose.addEventListener('click', () => {
        sidenoteAside.classList.add('is-hidden');
        sidenoteAside.parentElement.classList.remove('is-active');
      });

    if (sidenoteText) {
      const isClamping = sidenoteText.scrollHeight <= sidenoteText.clientHeight;

      if (isClamping) {
        sidenoteButton && sidenoteButton.classList.add('is-hidden');
      }
    }

    if (index + 1 === sidenotes.length) {
      sidenoteAside && sidenoteAside.classList.add('is-last');
    }
  });

  // check collision on resize
  window.addEventListener('resize', () => {
    if (textmediaInTexts.length) {
      textmediaInTexts.forEach(textmediaInText => {
        const inTextSidenoteAsides = $$(
          '.textmedia__sidenote-aside',
          textmediaInText
        );

        const inTextButtons = $$(
          '.textmedia__sidenote-number',
          textmediaInText
        );

        inTextSidenoteAsides.forEach((inTextSidenoteAside, index) => {
          if (window.innerWidth >= 1199) {
            checkCollision(inTextSidenoteAsides, inTextSidenoteAside, index);
          } else {
            inTextSidenoteAside.removeAttribute('style');
          }
        });

        if (window.innerWidth < 1199) {
          inTextButtons.forEach((inTextButton, index) => {
            checkCollision(inTextButtons, inTextButton, index);
          });
        }
      });
    }
  });
}

// check collision when all textmedia images are loaded
if (textmediaInTexts.length) {
  textmediaInTexts.forEach(textmediaInText => {
    const inTextSidenoteAsides = $$(
      '.textmedia__sidenote-aside',
      textmediaInText
    );
    const inTextButtons = $$('.textmedia__sidenote-number', textmediaInText);
    const textmediaImages = $$('img', textmediaInText);

    if (textmediaImages.length) {
      const imagesSrcs = [];
      textmediaImages.forEach(image => {
        if (image.src) {
          imagesSrcs.push(image.src);
        } else {
          imagesSrcs.push(image.dataset.src);
        }
      });

      loadImages(imagesSrcs).then(_ => {
        if (window.innerWidth > 1199) {
          inTextSidenoteAsides.forEach((inTextSidenoteAside, index) => {
            checkCollision(inTextSidenoteAsides, inTextSidenoteAside, index);
          });
        }

        if (window.innerWidth <= 1199) {
          inTextButtons.forEach((inTextButton, index) => {
            checkCollision(inTextButtons, inTextButton, index);
          });
        }
      });
    }
  });
}
